import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { isNativePlatform } from './platform.js';

export function tap() {
  if (!isNativePlatform()) return;
  Haptics.impact({ style: ImpactStyle.Light }).catch(() => {});
}

export function impact() {
  if (!isNativePlatform()) return;
  Haptics.impact({ style: ImpactStyle.Medium }).catch(() => {});
}

export function success() {
  if (!isNativePlatform()) return;
  Haptics.notification({ type: 'SUCCESS' }).catch(() => {});
}

export function error() {
  if (!isNativePlatform()) return;
  Haptics.notification({ type: 'ERROR' }).catch(() => {});
}
